import { render } from "./PanelQuote.vue?vue&type=template&id=16fd1b3c"
const script = {}

import "./PanelQuote.vue?vue&type=style&index=0&id=16fd1b3c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__